import { ArrowLeft, CheckCircle2, Leaf, Users, Award, Zap } from "lucide-react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";

const MarutiFlyAshBricks = () => {
  const navigate = useNavigate();

  return (
    <div className="lp-page">
      {/* Header */}
        {/* Navigation */}
      <nav className="nav-bar" data-testid="main-navigation">
        <div className="nav-container">
          <div className="nav-logo" data-testid="company-logo">
            <img src={require('src/images/MarutiGroupLogo.jpg')} alt="Maruti Group Logo" className="w-10 h-10" />
            <span className="logo-text">MARUTI GROUP</span>
          </div>
          </div>
          </nav>
      <div className="lp-header">
        <div className="container">
          <Button
            variant="ghost"
            onClick={() => navigate("/")}
            className="back-btn"
            data-testid="back-to-home-btn"
          >
            <ArrowLeft className="mr-2 w-5 h-5" />
            Back to Home
          </Button>
        </div>
      </div>

      {/* Hero Section */}
      <section className="lp-hero" data-testid="lp-hero-section">
        <div className="lp-hero-content">
          <div className="lp-hero-text">
            <div className="orange-accent"></div>
            <h1 className="lp-title" data-testid="lp-title">
              Core Ventures
            </h1>
            <div className="lp-subtitle-box">
              <h2 className="lp-subtitle">Maruti FlyAsh Bricks</h2>
            </div>
            <p className="lp-description" data-testid="lp-description">
              Maruti FlyAsh Bricks, operating under the brand "FIVE STAR BRICKS", is a leading producer of eco-friendly fly ash bricks. Our commitment towards sustainability reduces soil depletion and air pollution while providing superior quality construction materials that meet industry standards.
            </p>
          </div>
          <div className="lp-hero-image">
            <div className="blue-circle"></div>
            <img 
             src={require('src/images/14.jpg')}
              alt="Flyash Bricks Production"
              className="building-image"
            />
          </div>
        </div>
      </section>

      {/* Eco-Friendly Manufacturing Section */}
      <section className="lp-plotting" data-testid="lp-plotting-section">
        <div className="lp-plotting-content">
          <div className="lp-plotting-image">
            <img 
               src={require('src/images/17.jpg')}
              alt="Eco-Friendly Manufacturing"
            />
          </div>
          <div className="lp-plotting-text">
            <div className="orange-bar"></div>
            <h2 className="lp-section-title orange-text" data-testid="plotting-title">
              Eco-Friendly Manufacturing:
            </h2>
            <p className="lp-section-description" data-testid="plotting-description">
              Our state-of-the-art manufacturing facility utilizes fly ash from thermal power plants, transforming waste into premium quality building materials. This process significantly reduces environmental impact, prevents soil degradation, and contributes to sustainable construction practices across the industry.
            </p>
            <div className="location-markers">
              <div className="location-item">
                <Leaf className="w-5 h-5 text-orange-600" />
                <span>100% Eco-Friendly Production</span>
              </div>
              <div className="location-item">
                <Zap className="w-5 h-5 text-orange-600" />
                <span>Energy-Efficient Process</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality & Performance Section */}
      <section className="lp-residential" data-testid="lp-residential-section">
        <div className="lp-residential-content">
          <div className="lp-residential-image">
            <img 
            src={require('src/images/20.png')}
              alt="Quality Standards"
            />
            <div className="orange-border-left"></div>
          </div>
          <div className="lp-residential-text">
            <h2 className="lp-section-title orange-text" data-testid="residential-title">
              Quality & Performance:
            </h2>
            <p className="lp-section-description" data-testid="residential-description">
              5 BRICKS are engineered for superior durability, strength, and reliability. Our products meet international standards and are available in custom sizes to meet diverse construction requirements. Each batch undergoes rigorous quality control to ensure consistency and excellence.
            </p>

            <div className="divider"></div>

            <h3 className="lp-subsection-title orange-text" data-testid="experience-title">
              Industry Leadership
            </h3>
            <p className="lp-section-description" data-testid="experience-description">
              As pioneers in eco-friendly brick manufacturing, we are setting new benchmarks for the construction industry. Our commitment to innovation and sustainability has established us as the preferred choice for environmentally conscious builders and developers.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="lp-stats" data-testid="lp-stats-section">
        <div className="container">
          <h2 className="section-title" data-testid="stats-title">Our Achievements</h2>
          <div className="lp-stats-grid">
            <div className="lp-stat-card" data-testid="stat-card-0">
              <Users className="stat-icon" />
              <div className="stat-value">500+</div>
              <div className="stat-label">Active Clients</div>
            </div>
            <div className="lp-stat-card" data-testid="stat-card-1">
              <Leaf className="stat-icon" />
              <div className="stat-value">100%</div>
              <div className="stat-label">Eco-Friendly</div>
            </div>
            <div className="lp-stat-card" data-testid="stat-card-2">
              <Award className="stat-icon" />
              <div className="stat-value">ISO</div>
              <div className="stat-label">Certified Quality</div>
            </div>
            <div className="lp-stat-card" data-testid="stat-card-3">
              <Zap className="stat-icon" />
              <div className="stat-value">10+</div>
              <div className="stat-label">Years in Business</div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="lp-features" data-testid="lp-features-section">
        <div className="container">
          <h2 className="section-title" data-testid="features-title">Why Choose 5 BRICKS?</h2>
          <div className="lp-features-grid">
            <div className="lp-feature-card" data-testid="feature-card-0">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Eco-Friendly</h3>
              <p>100% fly ash utilization reduces soil depletion and environmental pollution</p>
            </div>
            <div className="lp-feature-card" data-testid="feature-card-1">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Superior Quality</h3>
              <p>ISO certified bricks with consistent strength and durability across all batches</p>
            </div>
            <div className="lp-feature-card" data-testid="feature-card-2">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Custom Sizes</h3>
              <p>Available in multiple sizes to meet diverse construction specifications</p>
            </div>
            <div className="lp-feature-card" data-testid="feature-card-3">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Cost Effective</h3>
              <p>Competitive pricing without compromising on quality or environmental standards</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="lp-cta" data-testid="lp-cta-section">
        <div className="container">
          <div className="lp-cta-content">
            <h2 data-testid="cta-title">Build with Sustainability in Mind</h2>
            <p data-testid="cta-description">Partner with 5 BRICKS for eco-friendly, high-quality construction materials</p>
            <Button 
              size="lg" 
              className="cta-btn"
              onClick={() => navigate("/#contact")}
              data-testid="cta-contact-btn"
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </section>
       {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={require('src/images/MarutiGroupLogo.jpg')} alt="Maruti Group Logo" className="w-10 h-10" />
              <span>MARUTI GROUP</span>
            </div>
            <p className="footer-text">
              Building sustainable futures since 1987. Committed to quality, innovation, and customer satisfaction.
            </p>
          </div>
          <div className="footer-bottom">
            <p>© 2025 Maruti Group. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MarutiFlyAshBricks;
